import route from 'hooks/route';
import {
  clientDeskAndSurepvisorConfig,
} from '../constants/accesses';
import React from 'react';

export enum PromoCompaniesRouteTypes {
  NEW = 'new',
  ACTIVE = 'active',
}

export type PromoCompaniesRouteProps = {
  type: PromoCompaniesRouteTypes;
  id?: string;
};

export enum PromoCompaniesRoutePath {
  companies = '/promo-companies',
}

export const RootPromoCompaniesRoute = route({
  path: PromoCompaniesRoutePath.companies,
  component: React.lazy(() => import('pages/promo-companies/main')),
  accessConfig: clientDeskAndSurepvisorConfig,
});

export const PromoCompaniesRoute = route<PromoCompaniesRouteProps>({
  path: '/promo-companies',
  component: React.lazy(() => import('pages/promo-companies/main')),
  accessConfig: clientDeskAndSurepvisorConfig,
});